"use client";

import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
import { ShopBreadcrumbsProvider, useShopBreadcrumbs } from "@/integrations/wordpress/WordPressEcommerceShopBreadcrumbs";
import { EcommerceTermsProvider, useEcommerceTerms } from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
import { WP_Term_Query } from "@/integrations/wordpress/wp_term_query";
declare const wvcClient: {
  getCurrentWPTermQueryParams: () => Record<string, any>;
};
function ShopBreadcrumbsConsumer() {
  const {
    links,
    loading,
    error
  } = useShopBreadcrumbs();
  if (loading || error || links.length === 0) {
    return <div className="h-5 w-48 bg-muted/40 animate-pulse rounded-md" />;
  }
  const lastIndex = links.length - 1;
  return <Breadcrumb>
      <BreadcrumbList className="text-muted-foreground font-default text-xs sm:text-sm uppercase tracking-widest">
        {links.map((link, i) => <div data-index={i} key={link.href} className="inline-flex items-center gap-1.5 sm:gap-2.5">
            <BreadcrumbItem>
              {i === lastIndex ? <BreadcrumbPage className="text-foreground font-medium">
                  {link.title}
                </BreadcrumbPage> : <BreadcrumbLink href={link.href} className="text-muted-foreground hover:text-primary transition-colors">
                  {link.title}
                </BreadcrumbLink>}
            </BreadcrumbItem>
            {i < lastIndex && <BreadcrumbSeparator className="text-muted-foreground/60" />}
          </div>)}
      </BreadcrumbList>
    </Breadcrumb>;
}
function ArchiveTitleConsumer() {
  const {
    terms,
    loading,
    error
  } = useEcommerceTerms();
  if (loading) {
    return <div className="space-y-4">
        <div className="h-12 sm:h-16 lg:h-20 w-3/4 bg-muted/40 animate-pulse rounded-md" />
        <div className="h-4 w-2/3 bg-muted/30 animate-pulse rounded-md" />
      </div>;
  }
  if (error) {
    return <h1 className="font-default font-bold text-4xl sm:text-5xl lg:text-6xl xl:text-7xl tracking-tight text-foreground">
        Siemens Inventory
      </h1>;
  }
  const currentTerm = terms && terms.length > 0 ? terms[0] : null;
  const title = currentTerm?.name || "Siemens Inventory";
  const description = currentTerm?.description || "";
  return <div className="space-y-6">
      <div className="flex items-center gap-3">
        <span className="h-px w-12 bg-primary" aria-hidden="true" />
        <span className="font-mono text-xs uppercase tracking-[0.25em] text-primary">
          Catalogue
        </span>
      </div>

      <h1 className="font-default font-bold text-4xl sm:text-5xl lg:text-6xl xl:text-7xl tracking-tight text-foreground leading-[1.05]">
        {title}
      </h1>

      {description && <p className="font-default text-base sm:text-lg text-muted-foreground max-w-2xl leading-relaxed" dangerouslySetInnerHTML={{
      __html: description
    }} />}
    </div>;
}
export default function ArchiveTitle() {
  const current_wp_term_query_params = typeof window !== "undefined" && (window as any).wvcClient ? (window as any).wvcClient.getCurrentWPTermQueryParams() : {};
  const wp_term_query = new WP_Term_Query(current_wp_term_query_params);
  return <section data-section-id="3986" id="archive-title" className="bg-background text-foreground relative overflow-hidden">
      {}
      <div aria-hidden="true" className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-24 bg-gradient-to-b from-transparent via-border to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-border to-transparent" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20 lg:py-28">
        {}
        <div className="mb-10 sm:mb-14">
          <ShopBreadcrumbsProvider>
            <ShopBreadcrumbsConsumer />
          </ShopBreadcrumbsProvider>
        </div>

        {}
        <EcommerceTermsProvider wp_term_query={wp_term_query} className="archive-title-wrapper">
          <ArchiveTitleConsumer />
        </EcommerceTermsProvider>

        {}
        <div className="mt-12 sm:mt-16 flex items-center gap-6">
          <div className="h-px flex-1 bg-border" />
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-muted-foreground">IMCNC DESIGNS</span>
          <div className="h-px flex-1 bg-border" />
        </div>
      </div>
    </section>;
}